import {Component, OnInit} from '@angular/core';
import {RouterLink} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
    selector: 'app-error404',
    templateUrl: './error404.component.html',
    styleUrls: ['./error404.component.scss'],
    imports: [RouterLink, TranslatePipe]
})
export class Error404Component implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
